import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../../Recoil/Atom/snackBarState";
import * as tutorApi from "../../../api/educationApi/tutorApi";
import ConfirmButtonGroup from "../../../components/ConfirmButtonGroup";
import SubTitle from "../../../components/SubTitle";
import {useCreateMutation} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";
import * as Params from "../../../models/clientModels/interfaces/apiParams";
import {EDTutor, initializeTutor} from "../../../models/serverModels/education/EDTutor";
import {tutorSchema} from "../../../validation/toturSchema";
import TutorForm from "./TutorForm";

const CreateTutor = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EDTutor>,
    Params.Create<EDTutor>
  >({
    api: tutorApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate("/Education/TutorList");
        queryClient.invalidateQueries("TutorList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EDTutor>({
    defaultValues: initializeTutor,
    resolver: yupResolver(tutorSchema),
  });

  const {reset} = methods;

  const onSubmit: SubmitHandler<EDTutor> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeTutor, ...data},
    });
  };
  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="강사 추가" />
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <TutorForm />
        <ConfirmButtonGroup link="/Education/TutorList" cancelText="취소" confirmText="저장" />
      </form>
    </FormProvider>
  );
};

export default CreateTutor;
